import Quill from 'quill';
window.Quill = Quill;

import "quill/dist/quill.snow.css";